import AccountDepositInstantAccessSettings from "@/models/Accounts/DepositAccounts/Settings/AccountDepositInstantAccessSettings";
import BaseUpdateAccountSettings from "@/models/Accounts/Shared/BaseUpdateAccountSettings";
import PeriodType from "@/models/Shared/PeriodType";
import FundingWindowTriggerType from "@/models/Products/ProductSettings/DefaultSettings/FixedTerm/FundingWindowTriggerType";
import Amount from "@/models/Shared/Amount";

export default class UpdateAccountDepositInstantAccessSettingsRequest extends BaseUpdateAccountSettings {
    fundingWindowPeriodType: PeriodType;
    fundingWindowPeriodValue: number;
    fundingWindowTriggerType: FundingWindowTriggerType;
    initialDepositWindowPeriodType: PeriodType;
    initialDepositWindowPeriodValue: number;
    maximumBalance: Amount = new Amount();
    minimumBalance: Amount = new Amount();

    public constructor(settings: AccountDepositInstantAccessSettings, updatedAt: Date, defaultWalletCurrency?: string) {
        super(updatedAt);
        if (settings !== null) {
            // Create a copy of settings to de-reference the original settings and avoid changing them here
            const settingsCopy = JSON.parse(JSON.stringify(settings));
            this.fundingWindowPeriodType = settingsCopy.fundingWindowPeriodType;
            this.fundingWindowPeriodValue = settingsCopy.fundingWindowPeriodValue;
            this.fundingWindowPeriodValue = +this.fundingWindowPeriodValue;
            this.fundingWindowTriggerType = settingsCopy.fundingWindowTriggerType;
            this.initialDepositWindowPeriodType = settingsCopy.initialDepositWindowPeriodType;
            this.initialDepositWindowPeriodValue = settingsCopy.initialDepositWindowPeriodValue;
            this.initialDepositWindowPeriodValue = +this.initialDepositWindowPeriodValue;
            this.minimumBalance = settingsCopy.minimumBalance;
            this.minimumBalance.currency = defaultWalletCurrency;
            this.maximumBalance = settingsCopy.maximumBalance;
            this.maximumBalance.currency = defaultWalletCurrency;
        }
    }
}